import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel, VehcileCategoryDto, VehicleModelDto } from "@project-management-system/shared-models";
import { VehicleModelService } from "./vehicle-model-service";


@Controller('vehicle_model')
@ApiTags('/vehicle_model')
export class VehicleModelController {
    constructor(private service: VehicleModelService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllVehicleModel')
    async getAllVehicleModel(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllVehicleModel();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getAllVehicleModelByCategory')
    async getAllVehicleModelByCategory(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllVehicleModelByCategory(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createVehicleModel')
    @ApiBody({ type: VehicleModelDto })
    async createVehicleModel(@Body() req?: any): Promise<CommonResponseModel> {
        try {
            return await this.service.createVehicleModel(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/updateVehicleModel')
    @ApiBody({ type: VehicleModelDto })
    async updateVehiclemodel(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.updateVehiclemodel(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateVehicleModel')
    @ApiBody({ type: VehicleModelDto })
    async activateOrDeactivateVehicleModel(@Body() dto: any): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateVehicleModel(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}